
export default {
	props: {
		puzzleInfo: {
			type: Array,
			required: true,
		},
	},
	computed: {
		hasImages() {
			return this.puzzleInfo.some((group) =>
				group.words.some(
					(word) => typeof word === "object" && word.image_url
				)
			);
		},
	},
};
